export default {
    attribute: {//配置项
        label:'营业状态:',
        size: "medium",
        disabled: false,
        checked: true,
        showLable: true,
        cptTableData: [{ "name": "值", "value":"", "namekey": "value" }],
        openValue:'',
        closeValue:'',
        dataType:"string",
        labelColor:'#ffffff',
        fontSize:12,
    },
    cptDataForm: {//动态数据配置
        dataSource: 1, //默认数据源1:静态数据，2:api接口,3:SQL,4:数据集,5:websocket
        pollTime: 0,//默认轮询时间
        dataText: '{"value": true}',//静态数据，必须为JSON格式
        apiUrl: '/test',//默认api地址
        sql: 'select xxx'//默认sql
    }
}